import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import LossLimitDocs from '../../../../documentation/LossLimitDocumentation';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import { UnitIndicator } from '../../../../../../atomic/formElements/unitIndicator/UnitIndicator';
import { colors } from '../../../../../../../colorVars';

function LossLimitModule({ state }) {
  const [lossLimit, dispatchLossLimit, , setLossLimitEnabled] = state;
  const [amountDisplay, setAmountDisplay] = useState('');

  useEffect(() => {
    setLossLimitEnabled(true);
  }, []);
  useEffect(() => {
    setAmountDisplay(
      lossLimit.lossLimitMode === 'AMOUNT'
        ? lossLimit.amount
        : lossLimit.amount * 100
    );
  }, [state]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={LossLimitDocs} /> Loss Limit
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel} style={{ gridColumn: 'span 2' }}>
          <p className={style.labelAndIndicator}>
            <UnitIndicator
              margin="0 3px 0 0"
              height={12}
              width={12}
              color={
                lossLimit.lossLimitMode === 'AMOUNT'
                  ? colors.green
                  : colors.orange
              }
            />
            Unit
          </p>
          <select
            value={lossLimit.lossLimitMode}
            onChange={({ target }) => {
              dispatchLossLimit({
                lossLimitMode: target.value,
                amount: 0,
              });
            }}
          >
            <option value="AMOUNT">Dollar Amount</option>
            <option value="PERCENT">Percentage</option>
          </select>
        </div>
        {lossLimit.lossLimitMode === 'AMOUNT' ? (
          <div className={style.inputAndLabel}>
            <p>Amount</p>
            <NumberInputWithUnit
              inputWidth="70px"
              direction="left"
              type="number"
              value={amountDisplay}
              setValue={setAmountDisplay}
              onBlur={(value) => dispatchLossLimit({ amount: value })}
            >
              $
            </NumberInputWithUnit>
          </div>
        ) : (
          <div className={style.inputAndLabel}>
            <p>Amount</p>
            <NumberInputWithUnit
              direction="right"
              type="number"
              value={amountDisplay}
              setValue={setAmountDisplay}
              onBlur={(value) => dispatchLossLimit({ amount: value / 100 })}
            >
              %
            </NumberInputWithUnit>
          </div>
        )}
      </div>
    </div>
  );
}
LossLimitModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default LossLimitModule;
